/* global config */
import * as types from '../actionTypes';

const state = () => {
    return {
        webSDK: {
            loaded: false,
            error: false,
            errorMessage: ''
        }
    }
};

const actions = {
    [types.LOAD_WEB_SDK_REQUEST]({ commit }) {
        return new Promise((resolve, reject) => {
            window.addEventListener('load', () => {
                const scriptEl = document.createElement('script');

                scriptEl.src = config.webSDKLink;
                scriptEl.async = true;

                scriptEl.addEventListener('load', resolve);
                scriptEl.addEventListener('error', reject);

                document.body.append(scriptEl);

                const head = document.getElementsByTagName('head')[0];
                const link = document.createElement('link');
                link.id = 'pxlt-styles';
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = `${config.webSDKStyles}`;
                link.media = 'all';
                head.appendChild(link);
            });
        })
            .then(() => {
                commit(types.LOAD_WEB_SDK_SUCCESS);
            })
            .catch(error => {
                commit(types.LOAD_WEB_SDK_FAILURE, error);
            })
    },
};

const mutations = {
    [types.LOAD_WEB_SDK_SUCCESS](state) {
        state.webSDK = {
            loaded: true,
            error: false,
            errorMessage: ''
        }
    },
    [types.LOAD_WEB_SDK_FAILURE](state, payload) {
        state.webSDK = {
            loaded: false,
            error: true,
            errorMessage: payload
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
